import {
  BaseApplicantSchema as ApplicantSchema,
  OriginationTracking,
  HomeInformationInputSchema as SharedHomeInformationInputSchema,
} from '@applyonline/shared'
import * as yup from '@if/core/yup'
export const buildCreditApplicationSchemaObject = () => {
  const CreditApplicationSchema = yup.object({
    isSinglePayment: yup.boolean().required().default(false),
    merchantId: yup.string().required(),
    applicant: ApplicantSchema()
      .required()
      .when('isSinglePayment', {
        is: true,
        then: (schema) =>
          schema.concat(
            yup.object({
              currentJobs: yup.array().nullable(),
              otherIncomes: yup.array().nullable(),
              spending: yup.object().nullable(),
            }),
          ),
      }),
    beneficiaryTypeId: yup.integer().default(1),
    origination: yup.object<OriginationTracking>().nullable().default(null),
  })
  return CreditApplicationSchema
}

export type CreditApplication = yup.InferType<ReturnType<typeof buildCreditApplicationSchemaObject>> & {
  lastTouchOrigination: OriginationTracking | null,
  firstTouchOrigination: OriginationTracking | null
}

const CreditApplicationSchema = buildCreditApplicationSchemaObject()

const applicantWithoutContactSchema = () =>
  ApplicantSchema().pick(['firstName', 'middleName', 'lastName', 'genderId', 'languageId', 'birthDate', 'sin'])

const beneficiarySchema = CreditApplicationSchema.pick(['beneficiaryTypeId'])

export const PersonalInformationInputSchema = () =>
  yup.object({
    applicant: applicantWithoutContactSchema().concat(
      ApplicantSchema().pick(['cellPhone', 'homePhone', 'email', 'subscribeNewsletter']),
    ),
    ...beneficiarySchema.fields,
  })

export type PersonalInformationInput = yup.InferType<ReturnType<typeof PersonalInformationInputSchema>>

export const HomeInformationInputSchema = (isSinglePayment = false, birthDate?: string) => {
  const sharedSchema = SharedHomeInformationInputSchema(birthDate)

  if (isSinglePayment) {
    return sharedSchema.pick(['currentAddress'])
  }

  return sharedSchema
}

export interface HomeInformationInput {
  currentAddress: yup.InferType<ReturnType<typeof ApplicantSchema>>['currentAddress']
  spending?: yup.InferType<ReturnType<typeof ApplicantSchema>>['spending'] | null
}
